import { jsx, jsxs } from "./chunk-EBMUSV7F.mjs";
import { neutralDay } from "./chunk-6NWZQNAN.mjs";
// src/icon/Fill/CheckboxFill.tsx
function CheckboxFill(param) {
    var size = param.size, primaryColor = param.primaryColor, secondaryColor = param.secondaryColor;
    switch(size){
        case 16:
            return /* @__PURE__ */ jsx("div", {
                children: "\uC774\uBBF8\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
            });
        case 20:
            return /* @__PURE__ */ jsxs("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /* @__PURE__ */ jsx("rect", {
                        x: "3.33331",
                        y: "3.33331",
                        width: "13.3333",
                        height: "13.3333",
                        rx: "2",
                        fill: primaryColor !== null && primaryColor !== void 0 ? primaryColor : neutralDay.gray100,
                        stroke: primaryColor !== null && primaryColor !== void 0 ? primaryColor : neutralDay.gray100,
                        strokeWidth: "1.75"
                    }),
                    /* @__PURE__ */ jsx("path", {
                        d: "M6.8327 10.2727L8.91604 12.1667L13.4994 8",
                        stroke: secondaryColor !== null && secondaryColor !== void 0 ? secondaryColor : neutralDay.white,
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case 24:
            return /* @__PURE__ */ jsxs("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /* @__PURE__ */ jsx("rect", {
                        x: "4",
                        y: "4",
                        width: "16",
                        height: "16",
                        rx: "2",
                        fill: primaryColor !== null && primaryColor !== void 0 ? primaryColor : neutralDay.gray100,
                        stroke: primaryColor !== null && primaryColor !== void 0 ? primaryColor : neutralDay.gray100,
                        strokeWidth: "2",
                        strokeLinejoin: "round"
                    }),
                    /* @__PURE__ */ jsx("path", {
                        d: "M8.19922 12.3273L10.6992 14.6L16.1992 9.60001",
                        stroke: secondaryColor !== null && secondaryColor !== void 0 ? secondaryColor : neutralDay.white,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
    }
}
export { CheckboxFill };
